import {
    getUrlRedirectAlterAccountAuth,
    initialLetters,
    getUrlRedirectMyAccountAuth,
} from "../../../commons/utils/Utils";
import React, { useEffect, useState } from "react";
import styles from "./perfil.module.scss";
import { MdExitToApp, MdAutorenew, MdViewList } from "react-icons/md";
import UserManager from "../../../commons/utils/Auth/UserManager";

interface PerfilProps {
    children?: any;
    isLogged?: boolean;
    firstName?: string;
    lastName?: string;
    email?: string;
}
export const Perfil: React.FC<PerfilProps> = ({
    children,
    isLogged,
    firstName,
    lastName,
    email,
}) => {
    const [Logged, setLogged] = useState(false);

    return (
        <div className={styles.box}>
            <div
                className={styles.box__header}
                onClick={() =>
                    (window.location.href = getUrlRedirectMyAccountAuth())
                }
            >
                <div className={styles.box__header__initial_letters}>
                    {initialLetters(`${firstName} ${lastName}`)}
                </div>
                <div className={styles.box__header__info}>
                    <span className={styles.box__header__info__name}>
                        Olá, <strong>{firstName}</strong>
                    </span>
                    <span className={styles.box__header__info__email}>
                        {email}
                    </span>
                </div>
            </div>
            <hr className={styles.divisor} />
            <div className={styles.box__body}>
                <ul>
                    <li className={styles.box__body__item_list}>
                        Configurações da conta
                    </li>
                    <li
                        className={styles.box__body__item_list}
                        onClick={() =>
                            (window.location.href =
                                getUrlRedirectMyAccountAuth())
                        }
                    >
                        <div className={styles.box__body__item_list__ico}>
                            <MdViewList width={"18px"} height={"18px"} />
                        </div>
                        <div>
                            <a>Minha Conta</a>
                        </div>
                    </li>
                    <li
                        className={styles.box__body__item_list}
                        onClick={() =>
                            (window.location.href =
                                getUrlRedirectAlterAccountAuth())
                        }
                    >
                        <div className={styles.box__body__item_list__ico}>
                            <MdAutorenew width={"18px"} height={"18px"} />
                        </div>
                        <a>Alterar Cadastro</a>
                    </li>
                </ul>
            </div>
            <hr className={styles.divisor} />
            <div
                className={styles.box__body__item_list}
                onClick={() => UserManager.logout()}
            >
                <div className={styles.box__body__item_list__ico}>
                    <MdExitToApp width={"18px"} height={"18px"} />
                </div>
                <a>Sair</a>
            </div>
        </div>
    );
};
